
import './App.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import React, { useRef, useState } from 'react';

import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';

const Collection = "messages";


firebase.initializeApp({
  apiKey: "AIzaSyC6n--UAsOMsbmXZIynWWZ0uvb8J2azT-Y",
  authDomain: "groupchat-5fcdf.firebaseapp.com",
  projectId: "groupchat-5fcdf",
  storageBucket: "groupchat-5fcdf.appspot.com",
  messagingSenderId: "839340610438",
  appId: "1:839340610438:web:5709ee5d165927e9f39207",
  measurementId: "G-WCND0ZH59J"
})

const auth = firebase.auth();
const firestore = firebase.firestore();
// const analytics = firebase.analytics();

function App() {
  const [user] = useAuthState(auth);
  return (
    <div className="App">
      <header>
        <h1>Group Chat⚛️🔥💬</h1>
        <SignOut />
      </header>

      <section>
        {user ? <ChatRoom /> : <SignIn />}
      </section>

    </div>
  );
}

function SignIn() {

  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  }

  return (
    <>
      <button className="sign-in" onClick={signInWithGoogle}>Sign in with Google</button>
      <p>"welcome to the group chat, Be nice to each other.."</p>
      <p style={{float: "left"}}>- Abhishek Dubey</p>
    </>
  )

}

function SignOut() {
  return auth.currentUser && (
    <button className="sign-out" onClick={() => auth.signOut()}>Sign Out</button>
  )
}
export default App;

function ChatRoom() {
  const dummy = useRef();
  const messagesRef = firestore.collection(Collection);
  const query = messagesRef.orderBy('createdAt').limitToLast(30);


  const [messages] = useCollectionData(query, { idField: 'id' });

  const [formValue, setFormValue] = useState('');

  const sendMessage = async (e) => {
    e.preventDefault();
    var message_text =formValue; 
    var reply_to = "";
    setFormValue('');

    const { uid,displayName, photoURL } = auth.currentUser;
    const newDocRef = messagesRef.doc();

    var resid = null
    await messagesRef.add({
        text: message_text,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        uid,
        displayName,
        reply_to,
        photoURL,
        id: newDocRef.id
      }
    ).then(function(docRef) {
      resid = docRef.id;})
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });
    messagesRef.doc(resid).update({id:resid})


    
    dummy.current.scrollIntoView({ behavior: 'smooth' });
  }


  return (<>
    <main>
      
      {messages && messages.map(msg => <ChatMessage key={msg.id} message_id={msg.id} message={msg} />)}

      <span ref={dummy}></span>

    </main>

    <form onSubmit={sendMessage}>

      <input value={formValue} onChange={(e) => setFormValue(e.target.value)} placeholder="say something nice" />

      <button type="submit" disabled={!formValue}>🕊️</button>

    </form>
  </>)
}


function ChatMessage(props) {
  const { id, text, uid,displayName,reply_to, photoURL, createdAt } = props.message;
  var date = new Date(createdAt * 1000).toLocaleTimeString()
  var reply_data = null;
  if (! (reply_to==="" || reply_to== null))
  {
    reply_data = firestore.collection(Collection).doc(reply_to);

  }
  const chatoption = async (messageClass, message_id)=>{
    if (messageClass==='sent'){
      if (window.confirm('Delete this message?')) {

        await firestore.collection(Collection).doc(message_id).delete();
       
      } else {
        console.log('not deleted');
      }
    }
   
  }
  
  const messageClass = uid === auth.currentUser.uid ? 'sent' : 'received';

  return (<>
    <div className={`message ${messageClass}`}>
    
      <img alt = "profile" title={displayName} src={photoURL || 'https://api.adorable.io/avatars/23/abott@adorable.png'} />
        <p1>
        <div data-js-context-icon="true" className="option" style={{float:"right"}} >
          <span data-testid="down-context" data-icon="down-context" class="">
            <svg viewBox="0 0 18 18" width="18" height="18" class="" onClick={()=>chatoption(messageClass,id )}>
              <path fill="currentColor" d="M3.3 4.6 9 10.3l5.7-5.7 1.6 1.6L9 13.4 1.7 6.2l1.6-1.6z"></path>
            </svg>
          </span>
        </div>
          {text}
          <br/>
          <date>
            {date}
          </date>
        </p1>
    </div>
  </>)
}
